module.exports = __webpack_public_path__ + "img/35501-081_edit.b3870cca.jpg";